import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { WsreService } from '../../wsre.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-crack-records-dialog',
  templateUrl: './add-crack-records-dialog.component.html',
  styleUrls: ['./add-crack-records-dialog.component.scss']
})
export class AddCrackRecordsDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AddCrackRecordsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _wsreService: WsreService,
   
    private _service: NotificationsService) { }

    MeasurementPointID:number
    wsreId:number
    frameCrackRecordID:number=0
    side:number
    CrackName:string;
    Comment?:string;
    CrackLength?:number
  ngOnInit() {
    this.MeasurementPointID=this.data.MeasurementPointID     
   this.wsreId=this.data.wsreId
   this.side=this.data.side
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  uploadComponentCrackPhotos(result) {
    if (result)
      // this.loadComponentCrackphotos();
       console.log(result)
  }

  onSubmitClick()
  {
    this._wsreService.AddCrackNameCommentFrame(this.wsreId, this.frameCrackRecordID,this.MeasurementPointID,this.CrackName, this.Comment, this.side, this.CrackLength ).subscribe(result => {
      console.log(result)
      this.dialogRef.close();
        })
        
  }
}
